import store from '@/store';

import { get } from '@/helpers';
import debounce from 'debounce-promise';

import apolloProvider from '@/vue-apollo';
const apolloClient = apolloProvider.defaultClient;

// Queries import
import ProductGql from '@/extensions/shop/store/graphql/queries/Product.gql';
import ProductsPaginatedGql from '@/extensions/shop/store/graphql/queries/ProductsPaginated.gql';
import ProductsWithArticlesPaginatedGql from '@/extensions/shop/store/graphql/queries/ProductsWithArticlesPaginated.gql';

// import CategoriesGql from '@/extensions/shop/store/graphql/queries/Categories.gql';
import ShoppingCartGql from '@/extensions/shop/store/graphql/queries/ShoppingCart.gql';

// import ArticlesGql from '@/extensions/shop/store/graphql/queries/Articles.gql';

// Mutations import
import SaveShoppingCartGql from '@/extensions/shop/store/graphql/mutations/SaveShoppingCart.gql';
import CreatePurchaseGql from '@/extensions/shop/store/graphql/mutations/CreatePurchase.gql';
import ApprovePurchasePaymentGql from '@/extensions/shop/store/graphql/mutations/ApprovePurchasePayment.gql';

export default {
    // Queries
    fetchProductsPaginated: (data, withArticles = false) =>
        new Promise((resolve, reject) => {
            let query = ProductsPaginatedGql;
            if (withArticles) query = ProductsWithArticlesPaginatedGql;

            let filters = [];
            if (data.filters && data.filters.length) data.filters.forEach(entry => filters.push(entry));

            let cachePolicy = 'cache-first';
            if (process.env.VUE_APP_DISABLE_CACHE) {
                // TODO
                cachePolicy = 'no-cache';
            }

            apolloClient
                .query({
                    query,
                    fetchPolicy: cachePolicy,
                    variables: {
                        currentPage: parseInt(get(data, 'pageInfo.currentPage', 1)),
                        perPage: parseInt(get(data, 'pageInfo.perPage', 10)),
                        order: get(data, 'order', 'date'),
                        direction: get(data, 'direction', 'desc'),
                        filters
                    }
                })
                .then(({ data }) => resolve(data.CO_ProductsPaginated))
                .catch(err => reject(err));
        }),
    fetchProduct: variables => {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: ProductGql,
                    variables
                })
                .then(({ data }) => resolve(data.CO_Product))
                .catch(err => reject(err));
        });
    },
    // fetchCategories: variables => {
    //   return new Promise((resolve, reject) => {
    //     apolloClient
    //       .query({
    //         query: CategoriesGql,
    //         variables
    //       })
    //       .then(({ data }) => resolve(data.CO_Categories))
    //       .catch(err => reject(err));
    //   });
    // },
    // fetchArticles: variables => {
    //   return new Promise((resolve, reject) => {
    //     apolloClient
    //       .query({
    //         query: ArticlesGql,
    //         variables
    //       })
    //       .then(({ data }) => resolve(data.CO_Articles))
    //       .catch(err => reject(err));
    //   });
    // },
    fetchShoppingCart: articlePivots => {
        return new Promise((resolve, reject) => {
            const cartInput = { cartArticlePivotQtyInput: articlePivots };
            apolloClient
                .query({
                    query: ShoppingCartGql,
                    variables: cartInput
                })
                .then(({ data }) => resolve(data.CO_ShoppingCart))
                .catch(err => reject(err));
        });
    },
    // Mutations
    saveShoppingCart: articlePivots =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: SaveShoppingCartGql,
                    variables: {
                        shoppingCart: { articlePivots }
                    }
                })
                .then(({ data }) => resolve(data.CO_SaveShoppingCart))
                .catch(error => reject(error.message));
        }),
    debouncedSaveShoppingCart: debounce(async function(articlePivots) {
        return this.saveShoppingCart(articlePivots);
    }, 1000),
    saveShoppingCartLocal: (items, key = null) => {
        if (key === null) {
            key = get(store.getters['auth/member'], 'id') || 'guest';
        }

        let cart = JSON.parse(localStorage.getItem('cart')) || {};
        let articlePivots = [];
        items.forEach(item => {
            let propertyValues = [];
            item.propertyValues.forEach(value => {
                propertyValues.push({ id: value.id });
            });
            const articlePivot = {
                id: item.id,
                article: { id: get(item, 'article.id') },
                propertyValues,
                qty: item.qty
            };
            articlePivots.push(articlePivot);
        });
        cart[key] = articlePivots;
        localStorage.setItem('cart', JSON.stringify(cart));
    },
    getShoppingCartLocal: () => {
        const key = get(store.getters['auth/member'], 'id') || 'guest';
        const cart = JSON.parse(localStorage.getItem('cart')) || {};

        let result = cart[key];
        if (key !== 'guest' && result === undefined) {
            result = cart['guest'];
        }

        return result;
    },
    createPurchase: purchase =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreatePurchaseGql,
                    variables: { purchase }
                })
                .then(({ data }) => resolve(data.CO_CreatePurchase))
                .catch(error => reject(error.message));
        }),
    approvePayment: purchase =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: ApprovePurchasePaymentGql,
                    variables: { purchase }
                })
                .then(({ data }) => resolve(data.CO_ApprovePurchasePayment))
                .catch(error => reject(error.message));
        })
};
